<template>
  <img src="@/assets/gifs/loader.gif" class="animated-logo" :alt="$t('images.altText.loader')" />
</template>

<style lang="scss" scoped>
.animated-logo {
  @apply w-screen h-screen object-cover max-w-none absolute z-30;
}
</style>
